/*
* This code is the intellectual property of Bulb Inc. and other software publishers;
* it may not be altered, copied or disclosed without prior written approval.
* Copyright 2022, Bulb Inc. For more information, please email contact@hellobulb.com.
*/
import { Component, Inject, OnInit } from '@angular/core';
import { ButtonSize } from '../../../aero/aero-button/aero-button.component';
import { BulbMobileLauncherTranslationProvider } from '../translation-provider';
import { UtilitiesService } from '../utilities.service';

@Component({
  selector: 'bulb-launch-button',
  templateUrl: './launch-button.component.html',
  styleUrls: ['./launch-button.component.scss'],
  providers: [
    BulbMobileLauncherTranslationProvider,
  ],
  standalone: false,
})
export class LaunchButtonComponent {

  public buttonSize = ButtonSize.LARGER;

  constructor(private utilityService: UtilitiesService) {

  }

  checkIfOnIOS() {
    return this.utilityService.checkIfOnIOS();
  }

  openIOSApp() {
    return this.utilityService.openIOSApp();
  }

}
